import { render } from "./BaseButtonNeutral.vue?vue&type=template&id=472c074b&scoped=true"
import script from "./BaseButtonNeutral.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseButtonNeutral.vue?vue&type=script&setup=true&lang=js"

import "./BaseButtonNeutral.vue?vue&type=style&index=0&id=472c074b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472c074b"],['__file',"resources/js/vue/components/ui/BaseButtonNeutral.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "472c074b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('472c074b', __exports__)) {
    api.reload('472c074b', __exports__)
  }
  
  module.hot.accept("./BaseButtonNeutral.vue?vue&type=template&id=472c074b&scoped=true", () => {
    api.rerender('472c074b', render)
  })

}


export default __exports__